import { render, staticRenderFns } from "./Serach.vue?vue&type=template&id=3f778c8e&scoped=true&"
import script from "./Serach.vue?vue&type=script&lang=js&"
export * from "./Serach.vue?vue&type=script&lang=js&"
import style0 from "./Serach.vue?vue&type=style&index=0&id=3f778c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f778c8e",
  null
  
)

export default component.exports